export const downloadFile = (url: string, name: string = '') => {
  const a = document.createElement('a');
  a.href = url;
  a.download = name || url.split('/').pop() || 'file';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
